/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
export default function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/contains.js